<template>
    <a-spin
      tip="Your document is being processed, do not leave this page!"
      :spinning="loading.page"
    >
      <a-card>
      <span slot="title" class="m-text-title">Rekapitulasi Klaim Kesehatan Dokter</span>
      <a-tabs
          class="custom-tabs"
          :activeKey="tabActive"
          @change="handleTab"
      >
          <a-tab-pane key="list">
          <template slot="tab">
              <span>Daftar Klaim</span>
              <a-badge
              v-if="this.listData.length > 0"
              class="m-badge m-badge-small"
              :count="this.listData.length"
              :numberStyle="{ backgroundColor: 'red' }"
              >
              </a-badge>
          </template>
          <a-input-search placeholder="Pencarian" v-model="search" @change="onChangeSearch" 
              class="textsearch" :loading="loading.search"></a-input-search>
  
            <a-table
              :rowKey="(record, index) => { return index.toString(); }"
              size="small"
              bordered
              :scroll="{ x: 850 }"
              :columns="columns"
              :dataSource="listDataSearch"
              :loading="loading.tab"
              :pagination="pagination"
              :rowClassName="(record, index) => { return record.check == true ? 'selectedRow' : '' }"
            >
              <template slot="nomor" slot-scope="text,item,index">{{index+1}}</template>
              <template slot="create_date_and_tlc" slot-scope="item">
                <div style="display: flex; flex-direction: column;">
                  <span>{{ dateFormat(item.create_dt) }}</span>
                  <span>{{ item.tlc_create }}</span>
                </div>
              </template>
              <template slot="no_klaim" slot-scope="item">{{ item.no_klaim }}</template>
              <template slot="anggota" slot-scope="item">{{ item.anggota }}</template>
              <template slot="total_kwitansi" slot-scope="item">{{ item.total_kwitansi }}</template>
              <template slot="total_klaim" slot-scope="item">{{ formatRupiah(item.total_klaim) }}</template>
    
              <div slot="customTitle">
                Aksi
                <a-checkbox
                  style="padding-left:10px"
                  :checked="isAllChecked"
                  :indeterminate="isIndeterminate"
                  @change="onSelectAll"
                />
              </div>
              <template slot="aksi1" slot-scope="item">
                <a-button icon="eye" size="small" type="primary" @click="showModalView(item)"></a-button>
              </template>
              <template slot="aksi2" slot-scope="item" >
                <a-checkbox
                  :id="item.id_klaim_kesehatan_hdr"
                  v-model="item.check"
                  @change="onSelectedItem"
                />
              </template>
              <div slot="footer" class="m-text-right">
                <a-button type="primary" @click="showRekapModal" >Rekap</a-button>
              </div>
            </a-table>
          </a-tab-pane>
          <!-- page 2 -->
          <a-tab-pane key="rekap_realisasi">
            <template slot="tab">
                <span>Rekap Klaim</span>
            </template>
            <a-input-search placeholder="Pencarian" v-model="search2" @change="onChangeSearch" 
                class="textsearch" :loading="loading.search"></a-input-search>
  
            <a-table
              :rowKey="(record, index) => { return index.toString(); }"
              size="small"
              bordered
              :scroll="{ x: 850 }"
              :columns="columns_recap"
              :dataSource="listRekap"
              :loading="loading.tab"
              :pagination="pagination"
              :rowClassName="(record, index) => { return record.check == true ? 'selectedRow' : '' }"
            >
              <template slot="nomor" slot-scope="text,item,index">{{index+1}}</template>
              <template slot="no_rekap" slot-scope="item">{{ item.no_rekap }}</template>
              <template slot="create_dt" slot-scope="item">{{ dateFormat(item.create_dt) }}</template>
              <template slot="tlc_create" slot-scope="item">{{ item.tlc_create }}</template>
              <template slot="periode" slot-scope="item">{{ formatPeriode(item.periode) }}</template>
              <template slot="description" slot-scope="item">{{ item.description }}</template>
              <template slot="status" slot-scope="item">
                <a-tag :color="item.status == 'Completed' ? 'green' : 'red'">
                  {{ item.status }}
                </a-tag>
              </template>
              <template slot="action" slot-scope="item">
                <div class="action-section">
                  <a-button icon="eye" size="small" type="primary" @click="showManifest(item)"></a-button>
                  <a-button icon="delete" :disabled="item.status == 'Completed'" size="small" type="danger" @click="showConfirm(item)"></a-button>
                </div>
              </template>
            </a-table>
          </a-tab-pane>
      </a-tabs>
      </a-card>
  
      <a-modal
        v-model="modalVisible"
        v-if="modalVisible"
        :title="`Detail Klaim Kesehatan: ${labelNo}`"
        :maskClosable="false"
        @cancel="modalClose"
        :width="700"
        >
        <a-card class="d-flex flex-column nowrap">
          <a-list :grid="{ gutter: 16, lg: 1 }" :dataSource="detailData" :pagination="pagination" :loading="loading.detail">
            <a-list-item slot="renderItem" slot-scope="item, index">
                <a-card hoverable class="d-flex flex-column nowrap">
                <a-list-item-meta>
                    <ul slot="description" class="list-wrapper">
                      <a-row :gutter="16">
                        <a-col :xs="24" :lg="12">
                          <div>
                            <span style="font-weight: bold;">Tanggl Invoice</span>
                            <p>{{ item.tgl_invoice ? moment(item.tgl_invoice).format(getDefaultDateFormat) : '-' }}</p>
                          </div>
                          <div>
                            <span style="font-weight: bold;">Deskripsi</span>
                            <p>{{ item.deskripsi }}</p>
                          </div>
                        </a-col>
                        <a-col :xs="24" :lg="12">
                          <div>
                            <span style="font-weight: bold;">Nilai Klaim</span>
                            <p>{{ item.nilai_klaim ? formatRupiah(item.nilai_klaim) : '-' }}</p>
                          </div>
                          <div>
                            <span style="font-weight: bold;">Jensi Plafon</span>
                            <p>{{ item.jns_plafon ? item.jns_plafon : '-' }}</p>
                          </div>
                        </a-col>
                        <a-col :span="24">
                          <span style="font-weight: bold;">Catatan :</span>
                          <p>{{ item.note ? item.note : '-' }}</p>
                        </a-col>
                      </a-row>
                    </ul>
                </a-list-item-meta>
                </a-card>
            </a-list-item>
          </a-list>
        </a-card>
        <template slot="footer">
          <a-button type="primary" @click="modalClose">Oke</a-button>
        </template>
      </a-modal>
  
      <a-modal
      title="Proses Rekapitulasi Klaim Kesehatan Dokter"
        v-model="modalRekapVisible"
        v-if="modalRekapVisible"
      >
        <a-form-model ref="form" :model="formRekap" :rules="rules">
          <a-form-model-item label="Periode" prop="periode">
            <a-month-picker placeholder="Pilih periode" v-model="formRekap.periode" />
            <!-- :disabled-date="disabledMonth" -->
          </a-form-model-item>
          <a-form-model-item label="Catatan" prop="note">
            <a-textarea
              placeholder="Ketik catatan disini ... "
              :rows="4"
              v-model="formRekap.note"
            />
          </a-form-model-item>
        </a-form-model>
        <div class="box-bg" style="display: flex; justify-content: space-between; align-items: center;">
          <div>
            <h4 style="margin-bottom:0px"> {{ totalTransaksi }} Transaksi {{ totalPelaksana }} TLC</h4>
          </div>
          <div>
            <a-button type="primary" icon="eye" size="small" @click="showViewDetail"></a-button>
          </div>
        </div>
        <template slot="footer">
          <div>
            <a-button type="secondary" @click="closeModalRekap">Cancel</a-button>
            <a-button type="primary" :loading="loading.process" @click="onSubmitRekap">Proses</a-button>
          </div>
        </template>
      </a-modal>
  
      <a-modal
      title="View detail klaim"
      v-model="modalView">
        <a-table
          :rowKey="(record, index) => { return index.toString(); }"
          size="small"
          bordered
          :scroll="{ x: 850 }"
          :columns="columnsView"
          :dataSource="payloadDetail"
          :loading="loading.tab"
          :pagination="pagination"
        >
          <template slot="nomor" slot-scope="text,item,index">{{index+1}}</template>
          <template slot="create_date_and_tlc" slot-scope="item">
            <div style="display: flex; flex-direction: column;">
              <span>{{ dateFormat(item.create_dt) }}</span>
              <span>{{ item.tlc_create }}</span>
            </div>
          </template>
          <template slot="no_klaim" slot-scope="item">{{ item.no_klaim }}</template>
          <template slot="anggota" slot-scope="item">{{ item.anggota }}</template>
          <template slot="total_kwitansi" slot-scope="item">{{ item.total_kwitansi }}</template>
          <template slot="total_klaim" slot-scope="item">{{ formatRupiah(item.total_klaim) }}</template>
        </a-table>
        <template slot="footer">
          <a-button type="primary" @click="modalView=false">Oke</a-button>
        </template>
      </a-modal>
    </a-spin>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  import moment from "moment-business-days"
  import CurrencyFormat from "@/mixins/CurrencyFormat";
  
  const columns = [
    {
      title: "#",
      key: "nomor",
      align: "center",
      scopedSlots: { customRender: "nomor" },
      width: 50,
    },
    {
      title: "No. Klaim",
      key: "no_klaim",
      align: "center",
      scopedSlots: { customRender: "no_klaim" },
      width: 210,
    },
    {
      title: "Tanggal Buat / TLC",
      key: "create_dt",
      align: "center",
      scopedSlots: { customRender: "create_date_and_tlc" },
      width: 100,
    },
    {
      title: "Nama Anggota Keluarga",
      key: "anggota",
      align: "center",
      scopedSlots: { customRender: "anggota" },
      width: 210,
    },
    {
      title: "Jumlah Kwitansi",
      key: "total_kwitansi",
      align: "center",
      scopedSlots: { customRender: "total_kwitansi" },
      width: 100,
    },
    {
      title: "Total Klaim",
      key: "total_klaim",
      align: "center",
      scopedSlots: { customRender: "total_klaim" },
    },
    {
      slots: { title: 'customTitle' },
      key: "aksi1",
      align: "center",
      colSpan: 2,
      fixed: 'right',
      scopedSlots: { customRender: "aksi1" },
      width: 50,
      },
    {
      title: "Aksi",
      key: "aksi2",
      align: "center",
      colSpan: 0,
      fixed: 'right',
      scopedSlots: { customRender: "aksi2" },
      width: 50,
    },
  ]
  
  const columnsView = [
    {
      title: "#",
      key: "nomor",
      align: "center",
      scopedSlots: { customRender: "nomor" },
      width: 50,
    },
    {
      title: "No. Klaim",
      key: "no_klaim",
      align: "center",
      scopedSlots: { customRender: "no_klaim" },
      width: 210,
    },
    {
      title: "Tanggal Buat / TLC",
      key: "create_dt",
      align: "center",
      scopedSlots: { customRender: "create_date_and_tlc" },
      width: 100,
    },
    {
      title: "Nama Anggota Keluarga",
      key: "anggota",
      align: "center",
      scopedSlots: { customRender: "anggota" },
      width: 210,
    },
    {
      title: "Jumlah Kwitansi",
      key: "total_kwitansi",
      align: "center",
      scopedSlots: { customRender: "total_kwitansi" },
      width: 100,
    },
    {
      title: "Total Klaim",
      key: "total_klaim",
      align: "center",
      scopedSlots: { customRender: "total_klaim" },
    }
  ]
  
  const columnslogHistory = [
    {
      title: "#",
      scopedSlots: { customRender: "no" },
      align: "right",
      width: "35px"
    },
    {
      title: "Log. Absensi",
      dataIndex: "timestamp",
      align: "center",
    },
  ]
  
  const columns_recap = [
    {
      title: "#",
      key: "nomor",
      align: "center",
      scopedSlots: { customRender: "nomor" },
      width: 50,
    },
    {
      title: "No. Rekap",
      key: "no_rekap",
      align: "center",
      scopedSlots: { customRender: "no_rekap" },
      width: 200,
    },
    {
      title: "Tanggal",
      key: "create_dt",
      align: "center",
      scopedSlots: { customRender: "create_dt" },
      width: 150,
    },
    {
      title: "TLC Pembuat",
      key: "tlc_create",
      align: "center",
      scopedSlots: { customRender: "tlc_create" },
      width: 100,
    },
    {
      title: "Periode",
      key: "periode",
      align: "center",
      scopedSlots: { customRender: "periode" },
      width: 150,
    },
    {
      title: "Catatan",
      key: "description",
      align: "center",
      scopedSlots: { customRender: "description" },
    },
    {
      title: "Status",
      key: "status",
      align: "center",
      scopedSlots: { customRender: "status" },
    },
    {
      title: "Aksi",
      align: "center",
      scopedSlots: { customRender: "action" },
      width: 100,
    },
  ]
  
  const rules = {
    periode: {
      required: true,
      message: "Harap isi periode!",
      trigger: ["blur", "change"],
    },
    note: {
      required: true,
      message: "Harap isi catatan!",
      trigger: ["blur", "change"],
    },
  }
  
  export default {
    mixins: [CurrencyFormat],
    data(){
      return {
        listData: [],
        detailData: [],
        rekapData: [],
        loading: {
          page: false,
          search: false,
          tab: false,
          detail: false,
          process: false,
          submit: false
        },
        moment,
        tabActive: 'list',
        search: '',
        search2: '',
        columns,
        columnslogHistory,
        columnsView,
        columns_recap,
        pagination: {},
        checkAll: false,
        selectedItem: [],
        modalVisible: false,
        modalRekapVisible: false,
        modalView: false,
        labelNo: '',
        formRekap: {
          periode: null,
          note: ''
        },
        rules,
        totalPelaksana: 0,
        totalTransaksi: 0,
        payloadDetail: [],
        usedPeriode: []
      }
    },
  
    computed: {
      ...mapGetters([
        "getAuth",
        "getDefaultDateFormat",
        "getStandartFormatDate",
      ]),
      listDataSearch() {
        let result = null
          result = this.listData
          if (this.search) {
            result = _.filter(this.listData, (e) =>
              e.no_klaim && e.no_klaim.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
              e.create_dt && e.create_dt.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
              e.anggota && e.anggota.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
              e.tlc_create && e.tlc_create.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
              e.total_kwitansi && e.total_kwitansi.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 || 
              e.total_klaim && e.total_klaim.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
            )
          }
        return result
      },
      listRekap() {
        let result = null
          result = this.rekapData
          if (this.search2) {
            console.log('disini');
            
            result = _.filter(this.rekapData, (e) =>
              e.no_klaim && e.no_klaim.toLowerCase().indexOf(this.search2.toLowerCase()) >= 0 ||
              e.create_dt && e.create_dt.toLowerCase().indexOf(this.search2.toLowerCase()) >= 0 ||
              e.periode && e.periode.toLowerCase().indexOf(this.search2.toLowerCase()) >= 0 ||
              e.tlc_create && e.tlc_create.toLowerCase().indexOf(this.search2.toLowerCase()) >= 0 ||
              e.description && e.description.toLowerCase().indexOf(this.search2.toLowerCase()) >= 0
            )
          }
        return result
      },
  
      isAllChecked(){
        return this.selectedItem.length == this.listData.length
      },
      isIndeterminate(){
        return this.selectedItem.length > 0 && this.selectedItem.length < this.listData.length
      }
    },
  
    mounted(){
      this.fetchList()
    },
  
    watch: {
      tabActive(newVal, oldVal){
        this.selectedItem = []
        if(newVal == 'list'){
          this.fetchList()
        }else {
          this.fetchRecap()
        }
      }
    },
  
    methods: {
      onChangeSearch(e){
  
      },
  
      handleTab(e){
        this.tabActive = e
      },
  
      async fetchList(){
        this.loading.tab = true
        try {
          const response = await this.asyncAxiosGet('rekap_klaim_dokter/list', this.getAuth, {});
          this.listData = response.list
          this.usedPeriode = response.periode
          this.loading.tab = false
          
        } catch (error) {
          this.loading.tab = false
          console.log(error);
        }
      },
  
      async fetchDetail(id){
        this.loading.detail = true
        try {
          const payload = {
            id_klaim: id
          }
          const response = await this.asyncAxiosGet('rekap_klaim_dokter/detail_klaim', this.getAuth, payload);
          this.detailData = response.data
          this.loading.detail = false
          
        } catch (error) {
          this.loading.detail = false
          console.log(error);
        }
      },
  
      async fetchRecap(){
        this.loading.tab = true
        try {
          const response = await this.asyncAxiosGet('rekap_klaim_dokter/rekap_list', this.getAuth, {});
          this.rekapData = response.data
          this.loading.tab = false
          
        } catch (error) {
          this.loading.tab = false
          console.log(error);
        }
      },
  
      onSelectedItem(e){
        const index = e.target.id
        if (this.selectedItem.includes(index)) {
          this.selectedItem = this.selectedItem.filter(k => k !== index)
        } else {
          this.selectedItem.push(index)
        }
      },
  
      onSelectAll(e){
        const checked = e.target.checked
        this.selectedItem = [] // reset dulu biar aman
  
        this.listData.forEach(dt => {
          dt.check = checked
          if (checked) this.selectedItem.push(dt.id_klaim_kesehatan_hdr)
        })
      },
  
      dateFormat(date){
        return moment(date).format('DD-MM-YYYY');
      },
  
      formatDecimal(val) {
        if(Number(val) == 0){
          return 0;
        }else {
          return Number(val).toFixed(4)
        }
      },
  
      realisasijam(start, end) {
        let result = ""
        start = moment(start)
        end = moment(end)
        let durasi = moment.duration(end.diff(start));
        result = durasi.hours() + " jam " + durasi.minutes() + " menit"
        return result
      },
  
      showRekapModal(){
        const selectedData = this.listData.filter(dt => this.selectedItem.includes(dt.id_klaim_kesehatan_hdr))
        this.payloadDetail = selectedData
        if(selectedData.length > 0){
          this.modalRekapVisible = true
          const uniquePelaksana = [...new Set(selectedData.map(item => item.tlc_create))]
          this.totalPelaksana = uniquePelaksana.length
          this.totalTransaksi = selectedData.length
        }else {
          this.displayMessageValue("error-basic", "Pilih klaim terlebih dahulu");
        }
      },
  
      showModalView(data){
        this.modalVisible = true
        this.fetchDetail(data.id_klaim_kesehatan_hdr)
        this.labelNo = data.no_klaim
      },
  
      modalClose(){
        this.modalVisible = false
      },
  
      closeModalRekap(){
        this.modalRekapVisible = false
        this.formRekap.periode = null
        this.formRekap.note = ''
      },
  
      onSubmitRekap(){
        this.loading.process = true
        this.$refs.form.validate( async (valid) => {
          if(!valid){
            this.loading.process = false
            return true
          }
  
          const payload = {
            detail: this.payloadDetail,
            periode: this.formRekap.periode.format("YYYY-MM-DD HH:mm:ss"),
            note: this.formRekap.note
          }

          try {
            const response = await this.asyncAxiosPost("rekap_klaim_dokter/create", "json", this.getAuth, payload)
            this.displayMessageValue("success-basic", "Rekap klaim kesehatan berhasil dibuat");
            this.modalRekapVisible = false
            this.loading.process = false
            this.clearForm()
            this.fetchList()
          } catch (error) {
            this.loading.process = false
          }
        })
      },
  
      clearForm(){
        this.selectedItem = []
        this.formRekap.periode = null
        this.formRekap.note = ""
      },
  
      formatPeriode(val){
        const month = [
          "Januari",
          "Februari",
          "Maret",
          "April",
          "Mei",
          "Juni",
          "Juli",
          "Agustus",
          "September",
          "Oktober",
          "November",
          "Desember"
        ]
  
        if (!val) return "";
  
        const [year, monthNum] = val.split("-");
        const namaBulan = month[parseInt(monthNum, 10) - 1];
  
        return `${namaBulan} ${year}`;
      },
  
      showManifest(val){
        this.$router.push({ name: "rekap_klaim_dokter_manifest", params: {id: val.id_rekap_klaim} })
      },
  
      async deleteData(id){
        try {
          const payload = {
            id_rekap: id
          }
          const response = await this.asyncAxiosDelete('rekap_klaim_dokter/remove_rekap', "json", this.getAuth, payload)
          this.displayMessageValue("success-basic", "Success delete data");
          this.fetchRecap()
        } catch (error) {
          console.log(error);
        }
      },
  
      showConfirm(val){
        this.$confirm({
          title: 'Apakah anda yakin ingin menghapus ?',
          content: `${val.no_rekap_tarip}`,
          okText: 'Oke',
          cancelText: 'Cancel',
          onOk: () => {
            this.deleteData(val.id_rekap_klaim)
          }
        })
      },
  
      showViewDetail(){
        this.modalView = true
      },
  
      disabledMonth(current){
        if (!current) return false;
        const year = current.year();
        const month = (current.month() + 1).toString().padStart(2, "0");
        const periode = `${year}-${month}`;
  
        // disable kalau periode udah ada di DB
        return this.usedPeriode.includes(periode);
      },
  
    }
  }
  
  </script>
  
  <style>
    .box-bg{
      background: #80808063;
      padding: 10px;
      border-radius: 3px;
    }
  
    .textsearch{
      margin-bottom : 16px!important;
    }
  
    .action-section {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      gap: 10px;
    }

    .list-title {
        font-weight: bold !important;
    }
  </style>